<template>
  <div>
  <Breadcrumbs main="Settings" title="Limit Upgrade" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Limit Upgrade</h5>
                <span>Fill the form below to upgrade your limit.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                      <form class="theme-form is-validated" id="Submit_Transfer_Form">
                          <!-- Initiate the Transfer -->
                          <div id="InitiateTransfer" v-show="step === 1">
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Account Number <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.accountNumber" @change="getLimt" placeholder="Select From Account *" class="form-select acct-num"  name="AccountNumber" required="required"><option value="" disabled>Select From Account *</option>
                                        <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                      <span v-if="cummulativeLimit" class="text-danger font-small-2">* Your current limit is NGN{{new Intl.NumberFormat('en-NG', {}).format(cummulativeLimit)}}</span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="amount">Upgrade Amount <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <input class="form-control" @paste.prevent @keypress="isNumber" @keyup="formatNum" v-model="form.amount" min="0" id="Amount" name="Amount" placeholder="Enter Amount *" required="required" type="text" value="" />
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                                <div class="col-sm-9 col-xl-7">
                                <select class="form-control" v-model="form.securityQuestionId" id="securityQuestion" name="name" required>
                                  <option value="">Select Security Question</option>
                                  <option v-for="securityQuestion in userSecurityQuestion" :key="securityQuestion.id" :value="securityQuestion.id">{{securityQuestion.question}}</option>
                                </select>
                                </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.securityAnswer" id="SecurityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                                        <span @click="showAnswerPin" class="pull-right show-pin">{{answerType === 'password' ? 'show' : 'hide'}}</span>
                                    </div>
                                </div>
                              <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                                        <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show' : 'hide'"></span></div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                        <input style="background-color: red;" type="checkbox" name="checkbox" v-model="checked" value="check" id="agree" /> I have read and agree to the <a href="https://digitaltest.tajbank.com/files/LimitUpgradeIndemnity.pdf" class="primary-color" target="_blank">Terms and Conditions</a> &nbsp;<br /><br />
                                    </div>
                                </div>
                              <div class="row mt-4">
                                  <div class="col-sm-12 offset-lg-3 offset-sm-0">
                                      <button type="button" @click="submitRequest" class="btn btn-round btn-primary mr-1">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                                      </div>
                                      <div v-else>
                                        Submit<i class="fa fa-save ml-2"></i>
                                      </div>
                                      </button>
                                      <button type="button" @click="resetForm" class="btn btn-outline-danger">Cancel</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div id="RequestSuccessResponseSection" v-show="step === 2" class="animated fadeIn" style="display:block">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> REQUEST SUCCESSFUL!</h5>
                        <p>Limit Upgraded successfully!</p>
                        <router-link to="/dashboard/default">
                            <a class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
                        </router-link>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
    },
    data:() => ({
      form: {
        accountNumber: '',
        amount: '0.00',
        securityQuestionId: '',
        securityAnswer: '',
        transactionPin: '',
        platform: 1,
      },
      checked: false,
      step: 1,
      loading: false,
      type: 'password',
      answerType: 'password',
      transactionReference: '',
      cummulativeLimit : null,
      newFormatAmount: '',
      isSecurityQuestion: localStorage.getItem('isSecurityQuestion'),
    }),
    computed: {
      ...mapState({
        details: state => state.dashboard.dashboardData,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        userSecurityQuestion: state => state.authentication.userSecurityQuestion,
      }),
      userDetails() {
        return this.details ? this.details.customerDetails.userName : null;
      },
    },
    async mounted() {
      this.$store.dispatch('dashboard/getDashboardData').then((response) => {
        if(response.status === 200) {
          this.$store.dispatch('getUserSecurityQuestion', { username: this.userDetails, customerType: 2 });
        }
      });
      if(this.isSecurityQuestion === 'true') {
        this.$router.push('/settings/reset-security-question');
      }
    },
    methods : {
      formatNum(event) {
        if(this.form.amount === '') {
          this.form.amount = '0.00';
        } else {
          this.form.amount = event.target.value;
          const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
          this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        }
        if(event.key === 'Backspace' || event.key === 'Delete') {
          if(event.target.value.length <= 4) {
            const formatter = new Intl.NumberFormat('en-US');
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            if(event.target.value.length < 2) {
              this.form.amount = '0.00';
            }
          } else {
            const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2  });
            this.form.amount = formatter.format(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
            return;
          }
        }		
        // if(event.target.value.length === 2)    event.target.value = '0.00';
      },
      isNumber(event) {
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      showAnswerPin() {
        this.answerType = this.answerType === 'password' ? 'text' : 'password';
      },
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      getLimt() {
        const account = this.userAccounts.find(account => account.accountNumber === this.form.accountNumber);
        if (account) {
          this.cummulativeLimit = account.transactionLimit.cummulativeTransactionLimit;
        }
      },
      submitRequest() {
        const amount = this.form.amount;
        this.newFormatAmount = Number(amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2'));
        // check if fields are empty
        if (this.form.accountNumber === '' || this.form.amount === '' || this.form.amount === '0.00' || this.form.transactionPin === '' || this.form.securityQuestionId === '' || this.form.securityAnswer === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all the required fields!',
            type: 'error',
          });
          return;
        }
        if(this.form.amount === '0.00') {
          this.$swal({
            title: 'Oops...',
            text: 'Amount cannot be NGN0.00',
            type: 'error',
          });
          return;
        }if(this.checked === false) {
          this.$swal({
            title: 'Oops...',
            text: 'Please agree to the terms and conditions!',
            type: 'error',
          });
          return;
        } else {
          this.loading = true;
          const data = {
            accountNumber: this.form.accountNumber,
            singleTransactionLimit: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            cummulativeTransactionLimit: Number(this.form.amount.replace(/\D/g, '').replace(/([0-9])([0-9]{2})$/, '$1.$2')),
            securityQuestionID: this.form.securityQuestionId,
            answer: this.form.securityAnswer,
            transactionPin: this.form.transactionPin,
            platform: this.form.platform,
          };
          this.$store.dispatch('settings/limitUpgrade', data).then(() => {
              this.loading = false;
              this.step = 2;
          }).catch((error) => {
            this.loading = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
            });
          });
        }
      },
      resetForm() {
        this.form.accountNumber = '';
        this.form.amount = '0.00';
        this.form.transactionPin = '';
        this.form.securityQuestionId = '';
        this.form.securityAnswer = '';
        this.checked = false;
      },
    },
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.vdp-datepicker {
  width: 485px !important;
}
</style>